import './app/adm/shared/config/quill-pt-br-config';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import Quill from 'quill';


Quill.import('ui/icons');

const tooltips = {
    bold: 'Negrito',
    italic: 'Itálico',
    underline: 'Sublinhado',
    // strike: 'Tachado',
    // blockquote: 'Citação',
    // code: 'Código',
    // codeBlock: 'Bloco de Código',
    // header: 'Cabeçalho',
    // list: 'Lista',
    // bullet: 'Marcador',
    link: 'Link',
    // image: 'Imagem',
    // video: 'Vídeo',
    // clean: 'Limpar Formatação',
    // undo: 'Desfazer',
    // redo: 'Refazer',
    // edit: `Editar`,
};

Object.entries(tooltips).forEach(([key, value]) => {
    const tooltip = Quill.import('ui/icons')[key];
    if (tooltip) {
        Quill.import('ui/icons')[key] = `<span title="${value}">${tooltip}</span>`;
    }
});


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
